import React from "react";
import styled from "@emotion/styled";
import { Item } from "@radix-ui/react-dropdown-menu";

import Button, { AnchorButtonProps, ButtonButtonProps } from "../button/Button";

type CommonDropdownMenuItemProps = {
  onSelect?: (event: Event) => void;
  textValue?: string;
};

type DropdownMenuItemProps =
  | (CommonDropdownMenuItemProps & Omit<AnchorButtonProps, "as"> & { as: "a" })
  | (CommonDropdownMenuItemProps &
      Omit<ButtonButtonProps, "as"> & { as?: "button" | undefined; href?: never });

const createStyledButton = <T extends {}>(Component: React.ComponentType<T>) =>
  styled(Component)(({ theme }) => ({
    width: "100%",
    justifyContent: "left",
    // TODO: Move more of the styling into the button itself
    "&:hover, &:focus": {
      backgroundColor: theme.colors.sysPrimarySubtle,
      color: theme.colors.sysPrimaryHover,
    },
    "&:hover": {
      outline: "none",
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: theme.colors.sysTextInactive,
      cursor: "not-allowed",
    },
  }));

const StyledButtonAsButton = createStyledButton(Button as React.ComponentType<ButtonButtonProps>);
const StyledButtonAsAnchor = createStyledButton(Button as React.ComponentType<AnchorButtonProps>);

const DropdownMenuItem = ({ onSelect, textValue, ...props }: DropdownMenuItemProps) => {
  return (
    <Item
      asChild
      // Cannot use `disabled` prop on anchor elements
      disabled={props.as !== "a" && props.disabled}
      onSelect={onSelect}
      textValue={textValue}
    >
      {props.as === "a" ? (
        <StyledButtonAsAnchor
          buttonStyle="inverse"
          buttonType="primary"
          {...(props as AnchorButtonProps)}
        />
      ) : (
        <StyledButtonAsButton
          buttonStyle="inverse"
          buttonType="primary"
          {...(props as ButtonButtonProps)}
        />
      )}
    </Item>
  );
};

export default DropdownMenuItem;
